import React from 'react'
import {useEffect, useState} from 'react'

function Joke(){

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [joke, setJoke] = useState([]);
    const current = new Date();
    const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;


    useEffect(() => {
        fetch("/jokes.json")
          .then(res => res.json())
          .then(
            (result) => {
              setIsLoaded(true);
              setJoke(result);
              //console.log(result);
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              setIsLoaded(true);
              setError(error);
              console.log(error);
            }
          )
      }, [])

      if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {
            return (
                <React.Fragment>
                    <div className="row tall-row">
                        <div className="col-lg-12">
                            <h1 className="section-title">Joke (REST API)</h1>
                            <hr />
                        </div>
                    </div>

                    <div className="row center-text">

                        <div className="col-md-12">

                                <article style={{cursor: "pointer"}} className="col-md-8 col-md-offset-2">
                                    <h3>{date}</h3>
                                    <h2>{joke.category}</h2>
                                    <p>
                                        {joke.setup} {joke.delivery}
                                    </p>
                                </article>

                        </div>
                    </div>
                </React.Fragment>
            );
        }
}

export default Joke;